// src/utils/cookies.ts

declare global {
    interface Window {
        $cookies: typeof cookies;
    }
}

/**
 * Get the shared root domain for cross-subdomain cookies.
 * e.g., 'app.aquassist.xyz' -> '.aquassist.xyz'
 */
function getSharedDomain(): string {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return '';
    }
    // Extract root domain (last two parts)
    const parts = hostname.split('.');
    if (parts.length >= 2) {
        return '.' + parts.slice(-2).join('.');
    }
    return '';
}

export const cookies = {
    get(name: string): string | undefined {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : undefined;
    },

    set(name: string, value: string, days = 7, useSharedDomain = false): void {
        const d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + d.toUTCString();
        const domain = useSharedDomain ? getSharedDomain() : '';
        const domainStr = domain ? `;domain=${domain}` : '';
        document.cookie =
            name + '=' + encodeURIComponent(value) + ';' + expires + ';path=/' + domainStr;
    },

    remove(name: string, useSharedDomain = false): void {
        const domain = useSharedDomain ? getSharedDomain() : '';
        const domainStr = domain ? `;domain=${domain}` : '';
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/' + domainStr;
    },

    isKey(name: string): boolean {
        return this.get(name) !== undefined;
    },

    keys(): string[] {
        return document.cookie.split(';').map((cookie) => cookie.trim().split('=')[0]);
    },
};

// Make it available on window for legacy code
window.$cookies = cookies;
